import { defineComponent, ref, watch, reactive, onBeforeMount } from 'vue';
import { MyButton, CommonTitle } from './components';
import LangVue from '@common/components/ui/lang.vue';
import { toast } from '@tencent/web-vbui/dist/components/t-toast/toast';
import { spin } from '@tencent/web-vbui/src/components/t-spin/spin';
import { TCheckbox } from '@tencent/web-vbui';
import { i18n, reportStatistics } from '@tencent/vb-web-base';
import { accountCheck, RESULTCODE } from '@tencent/vb-web-base/dist/accountTips';
import { isFusionBankApp, to } from '@tencent/vb-web-base-core';
import { baseMixins } from '@common/mixins/baseMixins';
import { GetInviteCodePersonalActInfo, GenerateInviteCode, QuerySpecificInfo } from '../../core/network/NodeAPI';
import ClipboardJS from 'clipboard';
import { openSharePanel, shareLink, ShareChannel, isCommonError, CallErrorType, shareImage, } from '@tencent/vb-app-bridge';
import Contract from '@tencent/vb-web-contract';
import html2canvas from 'html2canvas';
export default defineComponent({
    components: {
        MyButton,
        CommonTitle,
        TCheckbox,
        LangVue,
    },
    setup() {
        const { getT, getLang } = i18n;
        // i18n.setLang('en-GB');
        const $t = getT();
        const lang = getLang();
        const { setTitle, showModalError, isEng } = baseMixins();
        setTitle($t('贷款优惠活动'));
        const shareRef = ref(null);
        const isAgree = ref(false);
        const isShowAgreeTips = ref(false);
        const isSign = ref(true);
        const inviteCode = ref('');
        const awardAmt = ref('0');
        const shareVisible = isFusionBankApp;
        const contractPreviewInstance = new Contract({
            key: 'TeslaMGM01',
            autoSign: false,
            containerType: 'dialog',
            needAgree: false,
            hideBtn: true,
            needCheckBox: false,
            needTitle: false,
            needLogin: false,
        });
        const contractSignInstance = new Contract({
            key: 'TeslaMGM01',
            autoSign: false,
            containerType: 'dialog',
            needAgree: false,
            hideBtn: true,
            needCheckBox: false,
            needTitle: false,
        });
        // 活动页面配置
        const configInfo = reactive({
            rewardList: [],
            guideList: [],
            tipsList: [],
            inviteCodePrefix: '',
        });
        const getConfigInfo = async () => {
            const [data, err] = await to(GetInviteCodePersonalActInfo('invite-code-personal'));
            if (err) {
                showModalError(err.message, err.code);
            }
            if (data) {
                configInfo.inviteCodePrefix = data.inviteCodePrefix || 'Tesla';
                try {
                    configInfo.guideList = JSON.parse(data[`guideList_${lang}`]);
                    configInfo.tipsList = JSON.parse(data[`tipsList_${lang}`]);
                    configInfo.rewardList = JSON.parse(data[`rewardList_${lang}`]);
                }
                catch (err) {
                    showModalError('configuring data format errors');
                }
            }
        };
        const getRecommendReword = async () => {
            const [data, err] = await to(QuerySpecificInfo());
            if (err) {
                showModalError(err.message, err.code);
            }
            awardAmt.value = data.awardAmt;
        };
        // 检查协议是否已经签约，已签约情况自动调用接口生成邀请码
        const checkIsSign = async () => {
            const returnObj = await contractSignInstance.checkSign();
            if (returnObj.msg === 'hasContract') {
                isSign.value = true;
                const [data, err] = await to(GenerateInviteCode(configInfo.inviteCodePrefix));
                if (err) {
                    showModalError(err.message, err.code);
                }
                inviteCode.value = data.invitation_code;
            }
            else {
                isSign.value = false;
            }
        };
        onBeforeMount(async () => {
            spin.show();
            await getConfigInfo();
            spin.hide();
            const res = await accountCheck({
                needAutoLogin: true,
                loginReload: true,
                needActivateModal: true,
                needOpenModal: true,
            });
            if (res.code === RESULTCODE.LOGINRELOAD) {
                return;
            }
            if (res.code !== RESULTCODE.SUCCESS) {
                // navigator.pop();
                // 检测不成功 组件会走其他异常流程比如拉起开户 激活弹层
                return;
            }
            await checkIsSign();
            getRecommendReword();
        });
        watch(isAgree, (val) => {
            if (val) {
                timer && clearTimeout(timer);
                isShowAgreeTips.value = false;
            }
        });
        const checkProto = async () => {
            await contractPreviewInstance.preview();
        };
        let timer;
        // 立即邀请按钮点击
        const handleClick = async () => {
            reportStatistics({
                evtName: 'inviteBtnClick',
                desc: '个人邀请码活动页面立即邀请按钮点击',
            });
            if (!isSign.value && !isAgree.value) {
                isShowAgreeTips.value = true;
                timer && clearTimeout(timer);
                timer = setTimeout(() => {
                    isShowAgreeTips.value = false;
                }, 5000);
                return;
            }
            const res = await accountCheck({
                needAutoLogin: true,
                loginReload: true,
                needActivateModal: true,
                needOpenModal: true,
            });
            if (res.code === RESULTCODE.LOGINRELOAD) {
                return;
            }
            if (res.code !== RESULTCODE.SUCCESS) {
                // navigator.pop();
                // 检测不成功 组件会走其他异常流程比如拉起开户 激活弹层
                return;
            }
            spin.show();
            const [, err1] = await to(contractSignInstance.sign());
            if (err1) {
                spin.hide();
                reportStatistics({
                    evtName: 'contractSignError',
                    desc: '签署tesla mgm合同失败',
                });
                showModalError(err1.message, err1.code);
                return;
            }
            reportStatistics({
                evtName: 'contractSignSuccess',
                desc: '签署tesla mgm合同成功',
            });
            const [data, err2] = await to(GenerateInviteCode(configInfo.inviteCodePrefix));
            if (err2) {
                spin.hide();
                showModalError(err2.message, err2.code);
            }
            inviteCode.value = data.invitation_code;
            spin.hide();
        };
        const copyCode = () => {
            const clipboard = new ClipboardJS('.invite-code-copy');
            reportStatistics({
                evtName: 'copyCode',
                desc: '复制邀请码',
            });
            clipboard.on('success', () => {
                toast.show({
                    title: $t('复制成功'),
                });
                clipboard.destroy();
            });
            clipboard.on('error', (err) => {
                console.log(err);
                toast.show({
                    title: $t('复制失败'),
                });
                clipboard.destroy();
            });
        };
        const handlePhoto = async () => {
            reportStatistics({
                evtName: 'photoShare',
                desc: '个人邀请码活动页面图片分享按钮点击',
            });
            spin.show();
            const dom = shareRef.value;
            html2canvas(dom, {
                logging: false,
                scale: window.devicePixelRatio,
                // width: dom.clientWidth, // dom 原始宽度
                // height: dom.clientHeight,
                scrollY: 0,
                scrollX: 0,
                useCORS: true,
                backgroundColor: '#ffffff',
            }).then(async (canvas) => {
                spin.hide();
                const imageBase64 = canvas.toDataURL('image/png');
                try {
                    const channel = await openSharePanel([
                        ShareChannel.FACEBOOK,
                        ShareChannel.WECHAT_MESSAGE,
                        ShareChannel.WECHAT_MOMENT,
                        ShareChannel.MESSENGER,
                        ShareChannel.MORE,
                    ]);
                    if (channel === ShareChannel.UNKNOWN) {
                        // 需要处理未知的渠道
                        return;
                    }
                    await shareImage(channel, { imagePath: imageBase64 });
                }
                catch (err) {
                    if (isCommonError(err)) {
                        if (err.type === CallErrorType.OTHER_ERROR) {
                            const { msg, result } = err.result;
                            if (result === '0') {
                                reportStatistics({
                                    evtName: 'photoShareSuccess',
                                    desc: '个人邀请码活动页面图片分享成功',
                                });
                            }
                            else {
                                reportStatistics({
                                    evtName: 'photoShareError',
                                    desc: '个人邀请码活动页面图片分享失败',
                                });
                            }
                            console.log(msg);
                            // const { result, msg } = err.result;
                            // console.log(result);
                            // 0    分享成功
                            // -1    分享失败
                            // -2    分享渠道对应app没安装
                            // -3    用户主动取消
                            // -4    相册权限未经用户授权    涉及图片操作时需要该权限
                        }
                    }
                }
            });
        };
        const handleLink = async () => {
            reportStatistics({
                evtName: 'linkShare',
                desc: '个人邀请码活动页面链接分享按钮点击',
            });
            try {
                const channel = await openSharePanel([
                    ShareChannel.FACEBOOK,
                    ShareChannel.WECHAT_MESSAGE,
                    ShareChannel.WECHAT_MOMENT,
                    ShareChannel.MESSENGER,
                    ShareChannel.MORE,
                ]);
                if (channel === ShareChannel.UNKNOWN) {
                    // 需要处理未知的渠道
                    return;
                }
                /* eslint-disable */
                const result = await shareLink(channel, {
                    thumbPath: require('@/assets/images/inviteCodePersonal/share.png'),
                    title: $t('我在富融银行，送你9折减息券'),
                    link: `${window.origin}/h5/walletLoan/activity/index.html?inviteCode=${inviteCode.value}#/inviteCodeShare`,
                    content: $t('下载Fusion Bank APP，首次申请Tesla专享贷款并输入邀请码{inviteCode}，获批通过即可得9折Tesla专享贷款减息券', { inviteCode: inviteCode.value }),
                });
                if (result.result === '0') {
                    reportStatistics({
                        evtName: 'linkShareSuccess',
                        desc: '个人邀请码活动页面链接分享成功',
                    });
                }
            }
            catch (err) {
                if (isCommonError(err)) {
                    if (err.type === CallErrorType.OTHER_ERROR) {
                        const { msg, result } = err.result;
                        if (result !== '0') {
                            reportStatistics({
                                evtName: 'linkShareError',
                                desc: '个人邀请码活动页面链接分享失败',
                            });
                        }
                        console.log(msg);
                        // 0    分享成功
                        // -1    分享失败
                        // -2    分享渠道对应app没安装
                        // -3    用户主动取消
                        // -4    相册权限未经用户授权    涉及图片操作时需要该权限
                    }
                }
            }
        };
        // 分享页面
        const share = async () => {
            reportStatistics({
                evtName: 'linkShare',
                desc: '特斯拉邀请好友页面分享按钮点击',
            });
            try {
                if (isFusionBankApp) {
                    // 富融APP内分享
                    const channel = await openSharePanel([
                        ShareChannel.FACEBOOK,
                        ShareChannel.WECHAT_MESSAGE,
                        ShareChannel.WECHAT_MOMENT,
                        ShareChannel.MESSENGER,
                        ShareChannel.MORE,
                    ]);
                    if (channel === ShareChannel.UNKNOWN) {
                        // 需要处理未知的渠道
                        return;
                    }
                    const result = await shareLink(channel, {
                        link: `${window.origin}/common/detail.html?key=teslamgm0428`,
                        title: $t('富融银行优惠专区'),
                        content: '',
                        thumbPath: '',
                    });
                    if (result.result === '0') {
                        reportStatistics({
                            evtName: 'linkShareSuccess',
                            desc: '特斯拉邀请好友页面分享成功',
                        });
                    }
                }
            }
            catch (err) {
                if (isCommonError(err)) {
                    if (err.type === CallErrorType.OTHER_ERROR) {
                        const { msg, result } = err.result;
                        if (result !== '0') {
                            reportStatistics({
                                evtName: 'linkShareError',
                                desc: '特斯拉邀请好友页面分享失败',
                            });
                        }
                        console.log(msg);
                    }
                }
            }
        };
        // 预览合同
        async function previewContract(key) {
            const contractObj = new Contract({
                key,
                autoSign: false,
                containerType: 'dialog',
                needAgree: false,
                needLogin: false,
                needBackBtn: !isFusionBankApp,
                needTitle: !isFusionBankApp,
                needCheckBox: false,
                hideBtn: true,
            });
            await contractObj.preview();
        }
        return {
            lang,
            isEng,
            shareRef,
            configInfo,
            isSign,
            isAgree,
            isShowAgreeTips,
            inviteCode,
            awardAmt,
            shareVisible,
            previewContract,
            checkProto,
            handleClick,
            copyCode,
            handlePhoto,
            handleLink,
            share,
        };
    },
});
